import config from '@bymason/runtime-config';

export function getEndpointTemplate(
  path: string,
  appOrApiVersion: string,
  fleet?: string,
  localApiPort?: number
) {
  const domainUrl = localApiPort ? `http://localhost:${localApiPort}` : config.ApiDomainUrl;

  return fleet
    ? `${domainUrl}/${appOrApiVersion}/${fleet}/${path.startsWith('/') ? path.substring(1) : path}`
    : `${domainUrl}/${appOrApiVersion}/${path.startsWith('/') ? path.substring(1) : path}`;
}
